// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Invoice } from './invoice';
import { Job } from './job';
import { JobDumpsterFee } from './job-dumpster-fee';
import { QuickBooksProduct } from './quick-books-product';
import { Rental } from './rental';
import { RentalBillingLine } from './rental-billing-line';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class InvoiceLine extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get total() {
    return this.quantity * this.rate;
  }

  get tax() {
    return 0;
  }

  get totalWithTax() {
    return this.total + this.tax;
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createDate?: Date;
  createdBy?: string;
  deleted?: Date;
  description?: string;
  invoiceId!: number;
  isNonVisible!: boolean;
  jobDumpsterFeeId?: number;
  jobId?: number;
  lineNumber!: number;
  margin!: number;
  miscItem!: boolean;
  note?: string;
  quantity!: number;
  quickBooksProductId?: number;
  rate!: number;
  rentalId?: number;
  service?: string;
  weight?: string;
  invoice!: Invoice;
  job!: Job;
  jobDumpsterFee!: JobDumpsterFee;
  quickBooksProduct!: QuickBooksProduct;
  rental!: Rental;
  rentalBillingLines!: RentalBillingLine[];
}

